/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable eqeqeq */
import * as React from 'react'
import { faTrash, faPlus,
faClone,
faWarning,
faCircleCheck,
faExclamation} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button,  Stack
} from "react-bootstrap";
import EditableTable, { GroupedCol } from "../EditableTable";
import { ActionModalState, ConfirmButtonActions, HandleActionModal, InternalInvoiceEdit, InternalInvoiceReport, InternalInvoiceWithCsrdAndGroupId, InternalKeysForEIRT, InvoiceKey,  Reportedperiod,  /*ReportedPeriodReportType,*/ /*InvoicesWithCsrdAndGroupId,*/ TableCellOnChangeCallBack } from './editTypes';
import i18n from "../../i18n";
import {CellContext, ColumnDef, HeaderContext 
} from "@tanstack/react-table";
import { ReadFriendlyNumber, StringToNumber } from '../../lib/utils';
import { Contract } from '../../services/API/Contracts';
import { Customer } from '../../services/API/Customer';
import { Option } from 'react-bootstrap-typeahead/types/types';
import { ChoiceInput } from '../fields/ChoiceInput';
import { editUtils } from './editUtils';
// import { EditTableToolTip } from './EditTableToolTip';
// import { ReportPreview } from './ReportPreview';
import { EditTableToolTip } from './EditTableToolTip';
import { Department } from '../../services/API/Departments';

type InternalMap = {
  [key:number]:{[key:string]:any}
}

interface IEditInvoiceTableProps{
    reportType:InternalKeysForEIRT;
    data:InternalInvoiceReport/*InvoiceReport*/;
    callBack:TableCellOnChangeCallBack;
    invoiceKey:keyof InvoiceKey;
    addRow:(groupId?:number)=>void;
    deleteRow:(id:number)=>void;
    copyRow:<T extends object>(item:T,index:number) => void;
    deleteModal:ActionModalState/*DeleteModalState*/;
    handleDeleteModal:HandleActionModal/*HandleDeleteModal*/;
    contract:Contract[];
    customers:Customer[];
    reportedPeriods:{[key:string]:Reportedperiod[]};
    movedItems:(period:string,item:any,index:number,reportType:'InvoiceReport' | 'NullReport',action:ConfirmButtonActions,supplierOrgId:string,batchId?:string,departmentId?:number)=>void;
    departments?:Department[];
}
interface IEditInvoiceTableState{
  collapsedGroups:number[];
  cache:InternalMap;
  testStateForTOoltip:{[key:number]:{period:string,show:boolean}};
  
}
class EditInvoiceReportTable extends React.Component<IEditInvoiceTableProps,IEditInvoiceTableState>{
  constructor(props:IEditInvoiceTableProps){
    super(props)
    this._cell = this._cell.bind(this)
    this.handleCollapsingOfGroups = this.handleCollapsingOfGroups.bind(this)
    this.setCache = this.setCache.bind(this)
    this.state = {
      collapsedGroups:[],
      cache:{},
      testStateForTOoltip:{}
    }
  }
 
  timerHandler: NodeJS.Timeout | null = null;
 
  csrdCols:ColumnDef<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/>[] = [
    {
      id: "customer",
      header: () => i18n.t('invoiceReport.table.headers.customer'),
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => this._cell(props.row.original, "customerName",false,props.row.index),
      minSize: 100,
      footer: (info:HeaderContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => {
        // return <>{i18n.t('invoiceReport.table.footers.noOfRows')} {this.state.invoices.length}</>
      },
    },
    {
      id: "customerOrgId",
      header: () => i18n.t('invoiceReport.table.headers.customerOrgId'),
      minSize: 100,
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => this._cell(props.row.original, "customerOrgId",false,props.row.index)
    },
    {
      id: 'contractId',
      header: () => i18n.t('invoiceReport.table.headers.contractId'),
      minSize: 80,
      maxSize: 80,
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => this._cell(props.row.original, "contractId",false,props.row.index)
    },
    {
      id: 'invoiceNumber',
      header: () => i18n.t('invoiceReport.table.headers.invoiceNumber'),
      minSize: 100,
      maxSize: 100,
      
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => this._cell(props.row.original, "invoiceNumber",false,props.row.index)
    },
    {
      accessorKey: 'billingDate.formattedValue',
      header: () => i18n.t('invoiceReport.table.headers.date'),
      minSize: 150,
      maxSize: 150,
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => this._cell(props.row.original, "billingDate",false,props.row.index)
    },
    {
      id: "sumExclMoms",
      header: () => i18n.t('invoiceReport.table.headers.sum'),
      minSize: 80,
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => {
        if(this.props.data && this.props.invoiceKey){
          const buff = this.props.data.csrdGroup 
          return <div className="disabled-cell">
        {
          ReadFriendlyNumber(
            buff
            ?.filter((inv:any) => inv?.groupId == props.row.original?.groupId)
            .reduce((prev:any, curr:any) => {
              return prev + StringToNumber(curr?.rowSumExclMoms.toString())
            }, 0)
          )
        }
      </div>
        }else{
          return this._cell(props.row.original, "rowSumExclMoms",false,props.row.index) 
        }
      },
      footer: (info:HeaderContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => {
        if(this.props.data && this.props.invoiceKey){
          const buff = this.props.data.csrdGroup          
          const sum = buff?.reduce((prev:any, curr:any, i:any, self:any) => {
            if(typeof curr?.rowSumExclMoms == 'undefined'){
            
              return prev
            }else{
              const value = curr?.rowSumExclMoms?.toString().replaceAll(" ", "").replaceAll(',',".");
            return prev + parseFloat(value)
            }
            
          }, 0.0);
          return <>{i18n.t('invoiceReport.table.footers.totalSum')} {ReadFriendlyNumber(sum)}</>
        }       
      },
    },
    {
      id:"noOfArticles",
      header: () => i18n.t('invoiceReport.table.headers.noOfArticles'),
      minSize:40,
      maxSize:40,
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => {
        if(this.props.data && this.props.invoiceKey){
          const buff = this.props.data.csrdGroup 
          const groupItems = buff?.filter((inv:any) => inv?.groupId == props.row.original?.groupId);
        return <div className="disabled-cell">
          {
               groupItems?.length
          }
        </div>
        }
        
      }
    },
    {
      id:"warnings/errors",
      header: () => "",
      minSize:25,
      maxSize:25,
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => {
        if(this.props.data && this.props.invoiceKey){
          const buff = this.props.data.csrdGroup 
          const groupItems = buff?.filter((inv:any) => inv?.groupId == props.row.original?.groupId) as /*InvoicesWithCsrdAndGroupId*/InternalInvoiceWithCsrdAndGroupId[];
          
        let {errors,warnings} = {errors:0,warnings:0}
        const result = Object.keys(groupItems[0]).filter(x => x !== 'cpvCode' && x !== 'cpvName' &&x !=='emissionFactor' &&x !== 'resultStatus'&&x !=='totalEmissionsKg') ;
        groupItems.forEach(x => result.forEach((key:string) => {
          const value = x[key as keyof InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/];
          if (value === null || value === undefined  || value === '' || (key === 'billingDate' && value.toString() === 'Invalid Date') ) {

            errors += 1;
          }
        }));
        let icon = errors || warnings ? faWarning : faCircleCheck;
        let color = "#07a235";
        if(errors > 0) color = "#b30404";
        else if(warnings > 0) color = "#f8b133";
        return <>{
          <Stack direction="horizontal" gap={2} style={{height: "100%",justifyContent: "center"}}>
              <FontAwesomeIcon icon={icon} color={color} style={{height: "60%", marginRight: 6, marginLeft: 6}}/>
          </Stack>
        }</>
        }
      }
    },
     {
      accessorKey: "none",
      header: () => i18n.t('invoiceReport.table.headers.tools'),
      maxSize: 50,
      minSize: 50,
      cell: (props:CellContext<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,unknown>) => {
        return <Stack direction="horizontal" style={{height:42, justifyContent:"space-evenly"}} >
        <Button 
            className="outline-button row-btn" 
            onClick={(ev) => {
              this.props.handleDeleteModal('COPY',true,-1,'id',props.row.original,props.row.index)
            }}>
          <FontAwesomeIcon icon={faClone} />
        </Button>
        <Button 
          className="button outline-button-danger row-btn" 
          onClick={(ev) => {
           this.props.handleDeleteModal('DELETEROW',true,props.row.original.groupId,'groupId')
          }}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </Stack>
      },
      footer: () => {
        
        return <Button tabIndex={-1} className="button add-button" style={{height:"100%",padding:0, borderRadius: 0}} onClick={() => this.props.handleDeleteModal('ADDROW',true,-1) /*this.props.addRow()*/}>
          <FontAwesomeIcon icon={faPlus}/>
          {i18n.t('invoiceReport.table.footers.add')}
        </Button>
      },
      meta: "skipPaddingOnFooter"
    }
  ]
   groupedColumns: GroupedCol<InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/>[] = [
    {
      id: "articleNumber",
      header: i18n.t("invoiceReport.table.headers.articleNr"),
      cell: (item, index) => this._cell(item, "articleNumber",false,item.id),
      minSize: "100px"
    },
    {
      id: "articleText",
      header: i18n.t("invoiceReport.table.headers.articleText"),
      cell: (item, index) => this._cell(item, "articleText",false,item.id),
      minSize: "100px"
    },
    {
      id: "articleQuantity",
      header: i18n.t("invoiceReport.table.headers.articleQuantity"),
      cell: (item, index) => this._cell(item, "articleQuantity",false,item.id),
      minSize: "50px"
    },
    {
      id: "articleQuantityType",
      header: i18n.t("invoiceReport.table.headers.articleQuantityType"),
      cell: (item, index) => this._cell(item, "articleQuantityType",false,item.id),
      minSize: "30px"
    },
    {
      id: "articlePricePerUnit",
      header: i18n.t("invoiceReport.table.headers.articlePricePerUnit"),
      cell: (item, index) => this._cell(item, "articlePricePerUnit",false,item.id),
      minSize: "100px"
    },
    {
      id: "rowSumExclMoms",
      header: i18n.t("invoiceReport.table.headers.rowSumExclMoms"),
      minSize: "100px",
      cell: (item, index) => this._cell(item, "rowSumExclMoms",true,item.id),
    },
    {
      id: "nestedTools",
      minSize:"5%",
     header: "",
     cell: (row, index) => {
       return <Button 
         className="button outline-button-danger row-btn" 
         style={{ width: "100%" }}
         onClick={(ev) => {   
            this.props.handleDeleteModal('DELETEARTICLEROW',true,row.id,'id')
         }}>
         <FontAwesomeIcon icon={faTrash} />
       </Button>
     },
     footer: (col, groupId) => {
      return <Button tabIndex={-1} className="button add-button" style={{height:"100%",padding:0, borderRadius: 0}} 
        onClick={(e) => {
        this.props.handleDeleteModal('ADDARTICLE',true,-1,'groupId',undefined,groupId)
        }}>
        <FontAwesomeIcon icon={faPlus}/>
        {i18n.t("invoiceReport.newArticleText")}
      </Button>
    },
     meta: "skipPaddingOnFooter"
   }
  ];
  invoiceCOls:ColumnDef<InternalInvoiceEdit/*Invoice*/>[] = [
    {
      id: "customer",
      header: () => i18n.t('invoiceReport.table.headers.customer'),
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => this._cell(props.row.original, "customerName",false,props.row.index),
      minSize: 100,
      footer: (info:HeaderContext<InternalInvoiceEdit/*Invoice*/,unknown>) => {
        // return <>{i18n.t('invoiceReport.table.footers.noOfRows')} {this.state.invoices.length}</>
      },
    },
    {
      id: "customerOrgId",
      header: () => i18n.t('invoiceReport.table.headers.customerOrgId'),
      minSize: 100,
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => this._cell(props.row.original, "customerOrgId",false,props.row.index)
    },
    {
      id: 'contractId',
      header: () => i18n.t('invoiceReport.table.headers.contractId'),
      minSize: 80,
      maxSize: 80,
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => this._cell(props.row.original, "contractId",false,props.row.index)
    },
    {
      id: 'invoiceNumber',
      header: () => i18n.t('invoiceReport.table.headers.invoiceNumber'),
      minSize: 100,
      maxSize: 100,
      
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => this._cell(props.row.original, "invoiceNumber",false,props.row.index)
    },
    {
      accessorKey: 'billingDate.formattedValue',
      header: () => i18n.t('invoiceReport.table.headers.date'),
      minSize: 100,
      maxSize: 100,
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => this._cell(props.row.original, "billingDate",false,props.row.index)
    },
    {
      id: "priceExcMoms",
      header: () => i18n.t('invoiceReport.table.headers.sum'),
      minSize: 80,
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => {
        return this._cell(props.row.original, "priceExcMoms",false,props.row.index)
      },
      footer: () => {
        if(this.props.data && this.props.invoiceKey){
          const buff:any[] | undefined = this.props.data[this.props.invoiceKey] 
          const sum = buff?.reduce((prev:number, curr:InternalInvoiceEdit/*Invoice*/, i, self) => {
          const value = curr.priceExcMoms.toString().replaceAll(" ", "").replaceAll(',',"."); 
          return prev + parseFloat(value)
        }, 0.0);
        return <>{i18n.t('invoiceReport.table.footers.totalSum')} {ReadFriendlyNumber(sum)}</>
        }
      },
    },
    {
      id:"noOfArticles",
      header: () => i18n.t('invoiceReport.table.headers.noOfArticles'),
      minSize:40,
      maxSize:40,
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => {
        const groupItems = 1
        return <div className="fieldWrapper">
          {
            groupItems
          }
        </div>
      }
    },
    {
      id:"warnings/errors",
      header: () => "",
      minSize:25,
      maxSize:25,
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => {      
        let {errors,warnings} = {errors:0,warnings:0}
        const result = Object.keys(props.row.original).filter(x => x !== 'csrdConnectionId' && x !== 'status' && x !== 'id' && x !== 'customerId' &&x !=='priceIncMoms' &&x !== 'isRemoved'&&x !==' noOfInvoices' && x !== 'type' && x!== 'filePath' && x!=='projectName' && x!== 'projectEndDate' && x!=='comment' && x !== 'invoiceReference' && x !== 'invoiceIdentifier');
        result.forEach((key:string) => {
          const value = props.row.original[key as keyof InternalInvoiceEdit];
          if (value === null || value === undefined  || value === '' || (key === 'billingDate' && value.toString() === 'Invalid Date') ) {
            errors += 1;
          }
        })
        let icon = errors || warnings ? faWarning : faCircleCheck;
        let color = "#07a235";
        if(errors > 0) color = "#b30404";
        else if(warnings > 0) color = "#f8b133";
        return <>{
          <Stack direction="horizontal" gap={2} style={{/*height: "100%",*/justifyContent: "center"}}>
              <FontAwesomeIcon icon={icon} color={color} style={{height: "20px", marginRight: 6, marginLeft: 6}}/>
          </Stack>
        }</>      
      }
    },
     {
      accessorKey: "none",
      header: () => i18n.t('invoiceReport.table.headers.tools'),
      maxSize: 50,
      minSize: 50,
      cell: (props:CellContext<InternalInvoiceEdit/*Invoice*/,unknown>) => {
        return <Stack direction="horizontal" style={{height:42, justifyContent:"space-evenly"}} >
        <Button 
            className="outline-button row-btn" 
            onClick={(ev) => {
              this.props.handleDeleteModal('COPY',true,-1,'id',props.row.original,props.row.index)
             //this.props.copyRow(,props.row.index)
            }}>
          <FontAwesomeIcon icon={faClone} />
        </Button>
        <Button 
          className="button outline-button-danger row-btn" 
          onClick={(ev) => {              
            this.props.handleDeleteModal('DELETEROW',true,props.row.original.id)
          }}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </Stack>
      },
      footer: () => {
      
        return <Button tabIndex={-1} className="button add-button" style={{height:"100%",padding:0, borderRadius: 0}} onClick={()=>this.props.handleDeleteModal('ADDROW',true,-1)/*this.props.addRow()*/}>
          <FontAwesomeIcon icon={faPlus}/>
          {i18n.t('invoiceReport.table.footers.add')}
        </Button>
      },
      meta: "skipPaddingOnFooter"
    }
  ]
 componentDidMount(): void {
  if(typeof this.props.data.invoices !== 'undefined'){
    const checkboxes =  this.props.data.invoices?.reduce((acc:any,item,index) => {
      if(!acc[index]){
        acc[index] = {show:false,period:''};
      }
      return acc;
    },{})
    this.setState({testStateForTOoltip:checkboxes})
  }
     
 }
 componentDidUpdate(prevProps: Readonly<IEditInvoiceTableProps>, prevState: Readonly<IEditInvoiceTableState>, snapshot?: any): void {
     if(prevProps.data.invoices?.length !== this.props.data?.invoices?.length){
      if(typeof this.props.data.invoices !== 'undefined'){
        const checkboxes =  this.props.data.invoices?.reduce((acc:any,item,index) => {
          if(!acc[index]){
            acc[index] = {show:false,period:''};
          }
          return acc;
        },{})
        this.setState({testStateForTOoltip:checkboxes},() => console.log('*****************Added or removed'))
     }
    }
 }
  componentWillUnmount(): void {
    if (this.timerHandler) {
      clearTimeout(this.timerHandler);
    }
  }
 handleTimerAndCache = () => {

 }
 /**
 * Expands a collapsed group by removing its `groupId` from the collapsed groups list.
 * 
 * @param groupId - The ID of the group to expand.
 */
  handleCollapsingOfGroups(groupId:number){
    this.setState({collapsedGroups:this.state.collapsedGroups.filter(g => g != groupId)})
  }
  /**
 * Checks if a given key corresponds to a typeahead input field.
 * 
 * @param key - The key to check.
 * @returns `true` if the key requires a typeahead input, otherwise `false`.
 */
  checkKeyForTypeAheds = (key:string):boolean => {
    if(key == 'contractId' || key == 'customerOrgId' || key == 'customerName'){
      return true
    }
    else{
      return false
    }
  }
  /**
 * Returns available options for a typeahead input based on the given key.
 * 
 * @param key - The key for which options should be returned.
 * @returns An array of strings representing the available options.
 */
  returnOptionsForTypeAhead = (key:string):string[] =>{
    switch(key){
      case'contractId': return this.props.contract.map(x => `${x.contractId}`) 
      case 'customerOrgId': return this.props.customers.map(x => `${x.kndOrgnr}`) 
      case 'customerName':return this.props.customers.map(x => `${x.kndNamn}`)
      default: return [];
    }
  }
  /**
 * Caches a value for a given row and key.
 * 
 * @template T - The object type of the value being cached.
 * @param rowIndex - The index of the row to update.
 * @param key - The key within the row.
 * @param value - The value to cache.
 */
  setCache <T extends object> (rowIndex:number,key:string,value:T[keyof T]){
    const currentCache: InternalMap = { ...this.state.cache };
      if(!currentCache[rowIndex]){
        currentCache[rowIndex] = {}     
      }
      currentCache[rowIndex][key] = value;
      this.setState({cache:currentCache})
  }
  /**
 * Handles user search input and updates the cache accordingly.
 * 
 * @template T - The object type containing the searchable key.
 * @param searchString - The search string input by the user.
 * @param key - The key associated with the search.
 * @param index - The index of the row.
 * @param event - The change event from the input field.
 */
  handleSearch = <T extends object>(searchString:string,key:keyof T,index:number,event:React.ChangeEvent<HTMLInputElement>) =>{
  
    if(!this.state.cache[index]){
      
      this.setState({cache:{...this.state.cache,[index]:{[key]:searchString}}}/*,()=> console.log(this.state.cache)*/)
    }else{
      this.setState({cache:{...this.state.cache,[index]:{[key]:searchString}}}/*,()=> console.log(this.state.cache)*/)
      
    }
  }
 /**
 * Handles changes to the invoice date for a selected report.
 * 
 * @param period - The selected period.
 * @param item - The report item being modified.
 * @param index - The index of the item in the list.
 * @param reportType - The type of report.
 * @param action - The action performed.
 * @param batchId - (Optional) The batch ID associated with the report.
 */
  handleSelectedReportForInvoiceDateChange = (period:string,item:any,index:number,reportType:'InvoiceReport' | 'NullReport',action:ConfirmButtonActions,supplierOrgId:string,batchId?:string,departmentId?:number) => { 
    let check = structuredClone(this.state.testStateForTOoltip);
    const buff = structuredClone(item);
    //console.log(this.state.cache)
    buff["billingDate"] = this.state.cache[index]["billingDate"];
    Object.keys(check).forEach(x => {
        check[+x] = index == +x ? {period:period,show:!check[index]} : {period:'',show:false}; 
    })
    this.setState({testStateForTOoltip:check/*,cache:{}*/});
    this.props.callBack(buff,index);
    this.props.movedItems(period,item,index,reportType,action,supplierOrgId,batchId,departmentId); 
  }
  /**
 * Handles updates to the tooltip content for date changes.
 * 
 * @param invoiceDateChange - The new invoice date.
 * @param index - The index of the report item.
 * @param item - The report item being modified.
 */
  contentForDateToolTip = (invoiceDateChange:Date,index:number,item:any) => {
    const buff = structuredClone(item);    
    const invoiceDateChangedToPeriod:string= invoiceDateChange.toLocaleDateString('sv-SE',{year:'numeric',month:'2-digit'});
    const invoicesFrom = this.props.data.invoicesFrom.toLocaleDateString('sv-SE',{year:'numeric',month:'2-digit'});
    const invoicesTo =this.props.data.invoicesTo.toLocaleDateString('sv-SE',{year:'numeric',month:'2-digit'});
    /*OM DATUMET LIGGER UTANFÖR PROCESSEDDDDDDDD*/ 
    let check = structuredClone(this.state.testStateForTOoltip);
    Object.keys(check).forEach(x => {
        check[+x] = index == +x ? {period:invoiceDateChangedToPeriod,show:!check[index]} : {period:'',show:false}; 
    })
    this.setState(({testStateForTOoltip:check}),() =>{
      if((invoiceDateChangedToPeriod < invoicesFrom || invoiceDateChangedToPeriod > invoicesTo) == false){
        buff["billingDate"] = invoiceDateChange;
        this.props.callBack(buff,index);
        this.props.movedItems(invoiceDateChangedToPeriod,item,index,'InvoiceReport','POP',item.supplierOrgId,item?.batchId,-1); 
      }
    }) 
  }
  /**
 * Renders a table cell with different input types based on the value type.
 * 
 * @template T - The object type of the row.
 * @param item - The data row object.
 * @param key - The key of the property to render.
 * @param readOnly - Whether the field is read-only.
 * @param index - The index of the row.
 * @returns A JSX element representing the cell.
 */
_cell <T extends object>(item: T, key:keyof T,readOnly:boolean,index:number):JSX.Element {
  
  const style:React.CSSProperties={height:20,fontSize:'13px !important',padding:'0.3em'}
  const value = item[key];
  const isValidDate = value instanceof Date && !isNaN(value.getTime());
  const handleChange = <K extends keyof T>(e: React.ChangeEvent<HTMLInputElement> | Option[], key: K) => {   
      if(this.timerHandler){
        clearTimeout(this.timerHandler)
      }
      let newValue: T[K];
      if(!Array.isArray(e)){
        if (e.target.type === 'checkbox') {
          newValue = e.target.checked as T[K]; 
        } else if (e.target.type === 'date') {
          newValue = new Date(e.target.value) as T[K];
          this.contentForDateToolTip(newValue as Date,index,item);
        } else if(e.target.type === 'number'){
          newValue = +e.target.value as T[K]
        } 
        else {
          newValue = e.target.value as T[K];
        }
        const nextCacheRow: Record<string, unknown> = {
          ...(this.state.cache[index] ?? {}),
          [key as string]: newValue,
        };
        if (key === 'articleQuantity' || key === 'articlePricePerUnit') {
          const nextRow = structuredClone(item) as InternalInvoiceWithCsrdAndGroupId;
          (nextRow as any)[key] = newValue;

          const quantity = Number(String(nextRow.articleQuantity ?? 0).replace(',', '.'));
          const pricePerUnit = Number(String(nextRow.articlePricePerUnit ?? 0).replace(',', '.'));
          const sum = Number.isFinite(quantity) && Number.isFinite(pricePerUnit)
            ? quantity * pricePerUnit
            : 0;

          (item as any).rowSumExclMoms = sum;
          nextCacheRow.rowSumExclMoms = sum;
        }
        this.setState({ cache: { ...this.state.cache, [index]: nextCacheRow } });
        this.timerHandler = setTimeout(() => {
          item[key] = newValue;
          if(isValidDate){

          }else{
            this.props.callBack(item,index)
            this.setState({cache:{}})
          }
          
        },500)
      }
      else{

      newValue = e[0] as T[K]
      this.setCache(index,key as string,newValue)
      this.timerHandler = setTimeout(() =>{
        const buff:T =  structuredClone(item)
        buff[key] = newValue;
        const result:T|undefined = editUtils.UpdateCustomerBasedOnReportType(this.props.invoiceKey,key,buff,this.props.customers,this.props.contract,e);
        if(result !== undefined){
        this.props.callBack(result,index,key)
         
      }
      },300)}
    };
  
  const fields: Record<string, JSX.Element> = {
      bigint: <span>{JSON.stringify(value)}</span>,
      boolean: <input style={style} type="checkbox" checked={typeof this.state.cache?.[index]?.[key as string] == 'undefined' ?  value as boolean : this.state.cache?.[index]?.[key as string]} readOnly={readOnly} />,
      function: <span>Function</span>, 
      number:<label className='fieldWrapper'> <input required={true} type="number" value={typeof this.state.cache?.[index]?.[key as string] == 'undefined' ?  value as number : this.state.cache?.[index]?.[key as string]} readOnly={readOnly} onChange={(e) => handleChange(e,key)}/></label>,
      object: isValidDate ? (
        <>
        <EditTableToolTip departments={this.props.departments} handleSelectedReportForInvoiceDateChange={this.handleSelectedReportForInvoiceDateChange} contract={this.props.contract} selectedState={this.state.testStateForTOoltip} data={this.props.data} reportedPeriods={this.props.reportedPeriods} item={item} index={index}/>
        <label className='fieldWrapper'>
          <input 
          className='testarlite'
            required={true}
            type="date" 
            onChange={(e) => {
              const dateCheck = new Date(e.target.value) 
              if( dateCheck instanceof Date){
                handleChange(e,key)
              } }} 
              onKeyDown={(e) => e.preventDefault()}             
            value={(value as Date).toLocaleDateString() == null ?  '': (value as Date).toLocaleDateString()} 
            readOnly={readOnly}
          />
         
          </label>
          </>
        ) : (
          <span></span>
        ),
      string: this.checkKeyForTypeAheds(key as string) ? (
        <label className={`fieldWrapper ${typeof value == 'string' ? value.length == 0 ? 'fieldWrapper-error':'':''}`}>
        {typeof value == 'string' && value.length == 0 &&
           <FontAwesomeIcon
           className="exclamationIconStyle"
             icon={faExclamation}
           />
        }
        <ChoiceInput 
          disabled={readOnly}
          id={`${Math.random()}`}
          options={this.returnOptionsForTypeAhead(key as string)}
          selected={(typeof this.state.cache !== 'undefined' && typeof this.state.cache[index] !== 'undefined' && this.state.cache[index][key as string]) /*&& this.state.cache[index][key as string]*/  ? [this.state.cache[index][key as string]] : [item[key]] as Option[] }
          onChange={(selected:any) => {
            if(selected.length > 0){
            this.setState({cache:{}})
              handleChange(selected,key)   
           }
          }}
          onInputChange={(text,event) => {
           handleChange([text],key)
          }          
          }
          
        
        />
        </label>
    ): (<label className={this.isErrorClass(key,value)}>
        {typeof value == 'string' && value.length == 0 && 
           <FontAwesomeIcon
           className="exclamationIconStyle"
             icon={faExclamation}
           />
        }
      <input required={true}  type="text" readOnly={readOnly} onChange={(e) => handleChange(e,key)} value={typeof this.state.cache?.[index]?.[key as string] == 'undefined' ?  value as string : this.state.cache?.[index]?.[key as string]} /></label>
    ),
      symbol: <span>Symbol</span>,
      undefined: <span></span>
    };
    
     const fieldType = isValidDate ? 'object' : typeof value;
 
  return (
   <>{fields[fieldType] }</>
  )
}
/**
 * Determines the CSS class for an input field based on its value.
 * 
 * @param key - The key of the field.
 * @param value - The value of the field.
 * @returns The appropriate CSS class for the field.
 */
isErrorClass = (key:any,value:any) => {
    const lalaa = `fieldWrapper ${typeof value == 'string' ? value.length == 0  ? 'fieldWrapper-error':'':''}`
    if(key == 'invoiceIdentifier' || key == 'invoiceReference' || key == 'comment' || key == 'projectEndDate'){
      return 'fieldWrapper'
    }
    else{
      return lalaa
    }  
}
render(){
    const buff = this.props.data.csrdGroup as InternalInvoiceWithCsrdAndGroupId[]/*InvoicesWithCsrdAndGroupId[]*/ | undefined
    const  groupedItems =  buff?.reduce((prev:any, curr:any) => {
          const potentialGroup = prev.find((p:any) => p.groupId == curr?.groupId);
          if(potentialGroup){
            potentialGroup.items = potentialGroup?.items.concat(curr);
          }
          else {
            prev = prev.concat({ 
              ...curr,
              items: [curr]
             })
          }
          return prev;
        }, [] as InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/[]);
    return(
      <div style={{marginTop:20,background:'white',fontSize:'13px'}}>
       
        {this.props.data && this.props.invoiceKey  && (this.props.reportType == 'InvoicereportWithCSRD' || this.props.reportType == 'ProjectreportWithCSRD' )&& this.props.invoiceKey == 'csrdGroup' &&
          <EditableTable 
          columns={
           this.csrdCols
        } 
          grouped={
              {
            groupedColumns: this.groupedColumns,
            collapsedGroups: this.state.collapsedGroups,
            onCollapseGroup: (groupId:number) => { 
            
              const groupIdExists = this.state.collapsedGroups.includes(groupId);
              const newList = groupIdExists ? 
                this.state.collapsedGroups.filter(g => g != groupId)
                :
                this.state.collapsedGroups.concat(groupId);
               this.setState({collapsedGroups:newList})//setCollapsedGroups( newList);
            },
            onCollapseAll: () => {
              if(this.props.data && this.props.invoiceKey){
                const groupNumbers = this.props.data.csrdGroup?.map((inv:any) => inv?.groupId)
                
                .filter((grpId:any, i:any, self:any) => self.indexOf(grpId) == i) as number[];
              if(groupNumbers?.every((grpId:any) => this.state.collapsedGroups.includes(grpId))){
                this.setState({collapsedGroups:[]})//setCollapsedGroups([]);
              }else{
                this.setState({collapsedGroups:groupNumbers})//setCollapsedGroups( groupNumbers ?? [])  
              }
              }
            }
          }}
          
          data={groupedItems ?? []} 
          onChange={(newData) => console.log(newData)}
          />
        }
         {this.props.data && this.props.invoiceKey  && (this.props.reportType == 'Invoicereport' || this.props.reportType == 'Projectreport') && this.props.invoiceKey == 'invoices'  &&
               <EditableTable 
               columns={
               this.invoiceCOls
             } 
               data={this.props.data.invoices as InternalInvoiceEdit[] ?? []} 
               onChange={(newData) => console.log(newData)}
               />          
         }       
        </div>
    )
  }
}

export{
    EditInvoiceReportTable
}



